import React, { useState } from 'react'
import Popover from "../components/Popover";
import CategoryDropdown from "../components/Category";


const Filter = ({postTypes,cities,states,countries,handleCategorySelect,applyFilters,removeFilters,countItems,getSearchParam}) => {
    
    const [isListOpen, setIsListOpen] = useState(false);
  return (
    <div className="main-container mx-5 mt-6 mb-3 z-50">
        <div className='text-xl w-1/4 text-center font-bold border-gray-400 rounded-lg border-2 cursor-pointer' onClick={()=>{setIsListOpen(!isListOpen)}}>Filter</div>
        {isListOpen?<div className="absolute flex flex-col justify-evenly w-1/2 z-50 bg-black">
            <Popover
              trigger="click"
              content={
                <CategoryDropdown
                  categories={postTypes}
                  categoryName={"postType"}
                  onCategorySelect={handleCategorySelect}
                />
              }
              placement={["bottom"]}
            >
              <div
                className={`${"flex justify-center items-center gap-2.5 bg-[#161b22] text-white text-md font-bold cursor-pointer my-0 rounded-[1.25rem] border-[none] px-8 py-2"} ${
                  getSearchParam("postType") ? "text-[#181818] font-bold" : ""
                }`}
              >
                Post Categories&nbsp;
                {getSearchParam("postType") &&
                  `+${countItems(getSearchParam("postType") || "")}`}
              </div>
            </Popover>
            <Popover
              trigger="click"
              content={
                <CategoryDropdown
                  categories={cities}
                  categoryName={"city"}
                  onCategorySelect={handleCategorySelect}
                />
              }
              placement={["bottom"]}
            >
              <div
                className={`${"flex justify-center items-center gap-2.5 bg-[#161b22] text-white text-md font-bold cursor-pointer my-0 rounded-[1.25rem] border-[none] px-8 py-2"} ${
                  getSearchParam("city") ? "text-[#181818] font-bold" : ""
                }`}
              >
                Cities&nbsp;
                {getSearchParam("city") &&
                  `+${countItems(getSearchParam("city") || "")}`}
              </div>
            </Popover>
            <Popover
              trigger="click"
              content={
                <CategoryDropdown
                  categories={states}
                  categoryName={"state"}
                  onCategorySelect={handleCategorySelect}
                />
              }
              placement={["bottom"]}
            >
              <div
                className={`${"flex justify-center items-center gap-2.5 bg-[#161b22] text-white text-md font-bold cursor-pointer my-0 rounded-[1.25rem] border-[none] px-8 py-2"} ${
                  getSearchParam("state") ? "text-[#181818] font-bold" : ""
                }`}
              >
                States&nbsp;
                {getSearchParam("state") &&
                  `+${countItems(getSearchParam("state") || "")}`}
              </div>
            </Popover>
            <Popover
              trigger="click"
              content={
                <CategoryDropdown
                  categories={countries}
                  categoryName={"country"}
                  onCategorySelect={handleCategorySelect}
                />
              }
              placement={["bottom"]}
            >
              <div
                className={`${"flex justify-center items-center gap-2.5 bg-[#161b22] text-white text-md font-bold cursor-pointer my-0 rounded-[1.25rem] border-[none] px-8 py-2"} ${
                  getSearchParam("country") ? "text-[#181818] bg-gray-400 font-bold" : ""
                }`}
              >
                Countries&nbsp;
                {getSearchParam("country") &&
                  `+${countItems(getSearchParam("country") || "")}`}
              </div>
            </Popover>
            <div
              onClick={applyFilters}
              className="flex flex-col justify-center items-center bg-[#2E0052] text-white py-2 sm:my-0 px-8 rounded-2xl cursor-pointer"
            >
              Apply
            </div>
            <div
              className="flex flex-col justify-center items-center my-2"
              onClick={removeFilters}
            >
              <svg
                fill="#aa0000"
                className="w-6 h-6 cursor-pointer"
                viewBox="0 0 64 64"
                data-name="Layer 1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title />
                <path d="M50.86,13.38H13a1.5,1.5,0,0,1,0-3H50.86a1.5,1.5,0,0,1,0,3Z" />
                <path d="M42.4,57.93H21.48a5.5,5.5,0,0,1-5.5-5.5V11.87a1.5,1.5,0,0,1,1.5-1.5H46.4a1.5,1.5,0,0,1,1.5,1.5V52.43A5.51,5.51,0,0,1,42.4,57.93ZM19,13.37V52.43a2.5,2.5,0,0,0,2.5,2.5H42.4a2.5,2.5,0,0,0,2.5-2.5V13.37Z" />
                <path d="M40,13.37H23.9a1.5,1.5,0,0,1-1.5-1.5V6.57a1.5,1.5,0,0,1,1.5-1.5H40a1.5,1.5,0,0,1,1.5,1.5v5.3A1.5,1.5,0,0,1,40,13.37Zm-14.58-3H38.48V8.07H25.4Z" />
                <path d="M24.94,47.61a1.5,1.5,0,0,1-1.5-1.5V21.46a1.5,1.5,0,0,1,3,0V46.11A1.5,1.5,0,0,1,24.94,47.61Z" />
                <path d="M38.94,47.61a1.5,1.5,0,0,1-1.5-1.5V21.46a1.5,1.5,0,0,1,3,0V46.11A1.5,1.5,0,0,1,38.94,47.61Z" />
                <path d="M31.94,40.38a1.5,1.5,0,0,1-1.5-1.5V28.7a1.5,1.5,0,1,1,3,0V38.88A1.5,1.5,0,0,1,31.94,40.38Z" />
              </svg>
            </div>
        </div>:<></>}
    </div>
  )
}

export default Filter